import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import Sidebar from "../Common/Sidebar";
import Loader from "../Common/Loader";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { Dialog } from "primereact/dialog";
import { TabView, TabPanel } from "primereact/tabview";
import { Card } from "primereact/card";
import { Calendar } from "primereact/calendar";
import { Button } from "react-bootstrap";
import { Paginator } from "primereact/paginator";
import CommonValues from "../Common/utils";

export default function SupportCallLandingPage() {
  const [supportCallData, setSupportCallData] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [team, setTeam] = useState("");
  const [userName, setUserName] = useState("");
  const [direction, setDirection] = useState("");
  const [tag, setTag] = useState("");
  const [dateFrom, setDateFrom] = useState<Date | null>(null);
  const [dateTo, setDateTo] = useState<Date | null>(null);
  const [showWideSidebar, setShowWideSidebar] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();
  const [first, setFirst] = useState(0);
  const rows = 10;


useEffect(() => {
  const fetchSupportCallData = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("igtoken");
      if (!token) {
        setError("Token not found");
        setLoading(false);
        return;
      }
      const from = dateFrom ? dateFrom.toISOString().split("T")[0] : "";
      const to = dateTo ? dateTo.toISOString().split("T")[0] : "";
      const url = `${process.env.REACT_APP_Alexandria_API}/api/Alexandria/GetSupportCallHistory?fromDate=${from}&toDate=${to}`;
      const response = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const calls = Array.isArray(response.data?.data) ? response.data.data : [];
      const filteredCalls = calls.filter((call: any) => call.userName && call.userName.trim() !== "");

      setSupportCallData(filteredCalls);
      setError("");
    } catch (error : any) {
      if (error.response.status == 401) {
          navigate("/");
          CommonValues.Logout(navigate);}
      setError("Failed to load support call data.");
      setSupportCallData([]);
    } finally {
      setLoading(false);
    }
  };
  if (dateFrom && dateTo) {
    fetchSupportCallData();
  }
}, [dateFrom, dateTo]);

  useEffect(() => {
    const currentDate = new Date();
    const datefrom = new Date();
    datefrom.setDate(currentDate.getDate() - 7);
    setDateFrom(datefrom);
    setDateTo(currentDate);
  }, []);

  useEffect(() => {
    if (location.state?.filters) {
      const { team: fTeam, userName: fUser, direction: fDir, tag: fTag, dateFrom: fFrom, dateTo: fTo } = location.state.filters;
      setTeam(fTeam || "");
      setUserName(fUser || "");
      setDirection(fDir || "");
      setTag(fTag || "");
      if (fFrom) setDateFrom(new Date(fFrom));
      if (fTo) setDateTo(new Date(fTo));
    }
  }, [location.state]);

  const clearFilters = () => {
     const currentDate = new Date();
     const datefrom = new Date();
     datefrom.setDate(currentDate.getDate() - 7);
    setTeam("");
    setUserName("");
    setDirection("");
    setTag("");
    setDateFrom(datefrom);
    setDateTo(currentDate);
  };

  const filteredData = Array.isArray(supportCallData)
    ? supportCallData.filter((item: any) => {
        const filterTeam = team ? item.team?.toLowerCase().includes(team.toLowerCase()) : true;
        const filterUser = userName ? item.userName?.toLowerCase().includes(userName.toLowerCase()) : true;
        const filterDirection = direction ? item.direction?.toLowerCase().includes(direction.toLowerCase()) : true;
        const filterTag = tag ? item.tag?.toLowerCase().includes(tag.toLowerCase()) : true;
        const filterDateFrom = dateFrom ? new Date(item.callOccured) >= new Date(dateFrom) : true;
        const filterDateTo = dateTo ? new Date(item.callOccured) <= new Date(dateTo) : true;

        return filterTeam && filterUser && filterDirection && filterTag && filterDateFrom && filterDateTo;
      })
    : [];
    const paginatedData = filteredData.slice(first, first + rows);

  const onSummaryClick = (callData: any) => {
    navigate(`/supportcallanalysis/${callData.id}`, { state: { data: callData, filters: { team, userName, direction, tag, dateFrom, dateTo } } });
  };

  const summaryBodyTemplate = (rowData: any) => {
  const direction = rowData.direction?.toLowerCase(); 
  const isOutbound = direction === "outbound";
  const pillClass = isOutbound ? "direction-outbound" : "direction-inbound";
  return (
    <span className={`direction-pill ${pillClass}`}>
      {rowData.direction}
    </span>
  );
};

  const onSidebarValueChanged = (value: any) => {
    setShowWideSidebar(value);
  };
  const paginatedCardData = filteredData.slice(first, first + rows);
  const fetchCallAnalysisDetail = async (callId: number) => {
    try {
      const token = localStorage.getItem("igtoken");
      const response = await axios.get(
        `${process.env.REACT_APP_Alexandria_API}/api/Alexandria/support-call-analysis/${callId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      
      if (response.data.success) {
        return response.data.data;
      } else {
        return null;
      }
    } catch (error) {
      return null;
    }
  };

  return (
    <div className="d-flex vh-100 bg-light">

      <Sidebar pagename="supportcall" onSidebarValueChanged={onSidebarValueChanged}/>
      <div className="flex-grow-1 d-flex flex-column bg-light p-2 mt-4">
            <div
          className={` ${
            showWideSidebar
              ? "main-content-large-width"
              : "main-content-small-width"
          }`}
        >
       <div>
          <h2 className="fw-bold">Call Analysis Dashboard </h2>
          <p className="text-muted"></p>
        </div>
        <div className="card p-3">
           <div className="d-flex mt-4 mb-4 gap-4 dashboard-container">
              <div className="info-block dashboard-card shadow-hover p-4 rounded-4 w-100 d-flex align-items-center justify-content-between">
                <div>
                   <h2 className="dashboard-number mb-1">
                     {supportCallData.length}
                    </h2>
                     <p className="dashboard-label mb-0">
                    <i className="fas fa-phone-alt me-2"></i> Calls Analyzed
                  </p>
                </div>
              </div>
              <div className="info-block dashboard-card shadow-hover p-4 rounded-4 w-100 d-flex align-items-center justify-content-between">
               <div>
                  <h2 className="dashboard-number mb-1">
                    {supportCallData.length > 0
                     ? (
                      supportCallData.reduce(
                      (sum, call) => sum + parseFloat((call as any).analysisScore || "0"), 0
                       ) / supportCallData.length
                      ).toFixed(1)
                     : "0.0"}
                 </h2>
                  <p className="dashboard-label mb-0">
                    <i className="fas fa-chart-line me-2"></i> Avg. Analysis Score
                  </p>
              </div>
            </div>
           </div>
          <p className="text-purple header-text mb-1">Filter By:</p>
            <div className="row p-1 d-flex align-items-end" >
             <div className="col-md mb-1">
              <label htmlFor="dateFrom" style={{ fontSize: "12px", color: "#381574" }}>Date From</label>
                <Calendar
                    id="dateFrom"
                    value={dateFrom}
                    placeholder="dd-mm-yyyy"
                    readOnlyInput 
                    onChange={(e) => setDateFrom(e.value ?? null)}
                    maxDate={new Date()}
                    inputStyle={{fontSize: "12px", color: "#333",height: "30px",padding: "4px 8px",width: "100%",border: "1px solid #6e3bb7"}}
                    panelStyle={{ fontSize: "12px" }}
                    className="w-100"/>
             </div>
             <div className="col-md mb-1">
              <label htmlFor="dateTo" style={{ fontSize: "12px", color: "#381574" }}>Date To</label>
                 <Calendar
                    id="dateTo"
                    value={dateTo}
                    placeholder="dd-mm-yyyy"
                    readOnlyInput
                    onChange={(e) => setDateTo(e.value ?? null)}
                    maxDate={new Date()}
                    inputStyle={{ fontSize: "12px", color: "#333",height: "30px", padding: "4px 8px", width: "100%", border: "1px solid #6e3bb7" }}
                    panelStyle={{ fontSize: "12px" }}
                    className="w-100"/>
            </div>
            <div className="col-md mb-1">
                <label htmlFor="team" style={{ fontSize: "12px", color: "#381574" }}>Team</label>
                   <InputText
                      id="team"
                      value={team}
                      placeholder="Filter by Team Name"
                      onChange={(e) => setTeam(e.target.value)}
                      className="custom-inputbox"/>
            </div>
            <div className="col-md mb-1">
               <label htmlFor="user" style={{ fontSize: "12px", color: "#381574" }}>User Name</label>
                  <InputText
                    id="user" value={userName} placeholder="Filter by User Name"
                    onChange={(e) => setUserName(e.target.value)}
                    className="custom-inputbox"/>
            </div>
            <div className="col-md mb-1">
                <label htmlFor="direction" style={{ fontSize: "12px", color: "#381574" }}>Direction</label>
                  <InputText
                   id="direction" value={direction} placeholder="Filter by Direction"
                   onChange={(e) => setDirection(e.target.value)}
                   className="custom-inputbox" />
            </div>
            <div className="col-md mb-1">
                 <label htmlFor="tag" style={{ fontSize: "12px", color: "#381574" }}>Tag</label>
                  <InputText id="tag" value={tag} placeholder="Filter by Tag"
                    onChange={(e) => setTag(e.target.value)}
                    className="custom-inputbox" />
            </div>
            <div className="col-md-auto mb-1 d-flex align-items-end">
                 <Button
                  size="sm"
                  onClick={clearFilters}
                  className="fa fa-undo undo-btn"
                  title="Clear filters"/>
            </div>
         </div>
         <div>
           {loading ? (
              <div className="d-flex justify-content-center">
                <Loader />
              </div>
             ) : filteredData.length > 0 ? (
              <TabView className="mb-2 tabview-tab">
                <TabPanel header={<span>List View</span>}>
                <DataTable
                    value={filteredData}
                    globalFilter={globalFilter}
                    paginator rows={5}
                    className="support-call-table custom-bordered-datatable text-14"
                    onRowClick={(e) => {
                      navigate(`/supportcallanalysis/${e.data.id}`, { state: { data: e.data, filters: { team, userName, direction, tag, dateFrom, dateTo } } });
                    }}
                    rowClassName={(data) => 'clickable-row'} 
                  >
                    <Column field="userName" header="User Name" sortable />
                    <Column field="callOccured" header="Call Occured" sortable 
                    body={(rowData) => new Intl.DateTimeFormat('en-US', { 
                    year: '2-digit', month: '2-digit', day: '2-digit',hour: '2-digit', minute: '2-digit',}).format(new Date(rowData.callOccured))}/>
                    <Column field="callWith" header="Call With" sortable />
                    <Column field="team" header="Team" sortable />
                    <Column field="direction" header="Direction" body={summaryBodyTemplate} sortable />
                    <Column
                      field="analysisScore"
                      header="Analysis Score"
                      sortable
                      body={(rowData) => {
                        let scoreClass = "";
                        const score = parseFloat(rowData.analysisScore);
                        if (score < 7) scoreClass = "score-bad";
                        else if (score <= 8) scoreClass = "score-good";
                        else scoreClass = "score-best";
                        return <span className={`score-pill ${scoreClass}`}>{rowData.analysisScore}</span>;
                      }}
                    />
                    <Column field="tag" header="Tag" sortable />
                    {/* <Column field="actionTaken" header="Action Taken" /> */}
                  </DataTable>
                </TabPanel>

                <TabPanel header={<span>Card View</span>}>
                  <div  className="card-row">
                    {paginatedCardData.map((call: any, index) => {
                      const score = parseInt(call.analysisScore);
                      const scoreColor = score < 6 ? "#f77" : score > 8 ? "#a2f4b9e6" : "#f8ed12c0";
                      return (
                        <div key={index} className="card-col">
                        <div className="card-container" style={{ cursor: 'pointer' }}>
                        <div className="small-muted-text">User Name</div>
                        <div style={{ fontWeight: "bold", marginBottom: "8px" }}>{call.userName}</div>
                        <div className="row align-items-center">
                        <div className="col-6">
                        <div className="small-muted-text">Team</div>
                        <div className="styled-badge">{call.team}</div></div>
                        <div className="col-6 text-end text-md-start analysis-score-container">
                        <div className="small-muted-text">Analysis Score</div>
                        <div className="score-circle" style={{ backgroundColor: scoreColor }}> {call.analysisScore}</div></div></div>
                        <div className="small-muted-text mt-2">Call Occurred</div>
                        <div style={{ marginBottom: "10px" }}> {new Intl.DateTimeFormat('en-US',{year: '2-digit', month: '2-digit', day: '2-digit', 
                         hour: '2-digit', minute: '2-digit',}).format(new Date(call.callOccured))}</div>
                        <Button
                           onClick={() => onSummaryClick(call)}
                           style={{backgroundColor: "#3b0a69",fontSize: "12px",padding: "4px 8px",width: "100px",}}>
                           See Analysis
                        </Button>
                      </div>
                  </div>
                      );
                    })}
                  </div>
                  <div className="d-flex justify-content-center mt-3">
                   <Paginator
                    first={first}
                    rows={rows}
                    totalRecords={filteredData.length}
                    onPageChange={(e) => setFirst(e.first)}
                    rowsPerPageOptions={[4, 8, 12]}
                    template="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink"
                  />
                 </div>
                </TabPanel>
              </TabView>
           ) : ( 
          <div style={{ textAlign: 'center', color: 'gray', padding: '20px' }}>
            <p>No call logs are available!!</p>
          </div>
        )}
          </div>
        </div>
      </div>
    </div>
  </div>
  );
}